export const LOAD_CATEGORY = "LOAD_CATEGORY";
export const LOADING_CATEGORY = "LOADING_CATEGORY";
